<template>
  <v-checkbox
    class="text-capitalize mt-0 pt-2 mb-2"
    dense
    v-bind="$attrs"
    v-on="$listeners"
    :label="$t(label)"
    :input-value="value"
    :rules="rules"
    @change="val => $emit('input', val)"
  />
</template>

<script>
import { createValidationRules } from '@/utils'

export default {
  name: 'BaseCheckbox',

  props: {
    label: String,
    value: Boolean,
    required: Boolean
  },

  computed: {
    rules() {
      return createValidationRules({
        label: this.label,
        required: this.required
      })
    }
  }
}
</script>

<style scoped></style>
